/* ============================================================
   custom-countdown-bar.js - Cuenta atras de la barra superior

   Cuenta hasta una fecha real que se fija en el editor. No se
   reinicia sola ni inventa urgencia: cuando la fecha pasa, la
   barra desaparece. Si el JS no carga, la barra no llega a
   mostrarse, que es preferible a ensenar un contador muerto.
   ============================================================ */

class CountdownBar extends HTMLElement {
  connectedCallback() {
    this.clock = this.querySelector('[data-cbar-clock]');
    this.bar = this.querySelector('.cbar');

    const raw = this.dataset.deadline;
    if (!this.clock || !this.bar || !raw) return;

    this.deadline = new Date(raw).getTime();
    if (Number.isNaN(this.deadline)) return;

    if (this.tick() === false) return;

    this.bar.classList.add('is-live');
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  tick() {
    const left = this.deadline - Date.now();

    if (left <= 0) {
      clearInterval(this.timer);
      this.bar.classList.remove('is-live');
      return false;
    }

    const total = Math.floor(left / 1000);
    const days = Math.floor(total / 86400);
    const hours = Math.floor((total % 86400) / 3600);
    const mins = Math.floor((total % 3600) / 60);
    const secs = total % 60;
    const pad = (n) => String(n).padStart(2, '0');

    this.clock.textContent = days > 0
      ? `${days}d ${pad(hours)}:${pad(mins)}:${pad(secs)}`
      : `${pad(hours)}:${pad(mins)}:${pad(secs)}`;

    return true;
  }
}

if (!customElements.get('countdown-bar')) {
  customElements.define('countdown-bar', CountdownBar);
}
